import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/dashboard", { replace: true });
      return;
    }

    http
      .post("/auth/session", null, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => {
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      });
  }, [location.hash, navigate]);

  return <div className="p-10 font-mono-label" data-testid="auth-callback">Signing you in…</div>;
}
